// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1400":"64458a73c3e58eca","2029":"64458a73c3e58eca","2743":"648a4da5cd272a6b","7500":"64bae91be314108d","9740":"1f5206d833ce9dff"}[chunkId] + ".css";
};